import type { Commute } from '../types';
import type { CommuteFilters } from './getCommuteFiltersFromUrl';

const DEFAULT_COMMUTE_DESTINATION = null;
const DEFAULT_COMMUTE_METHOD = 'driving';
const DEFAULT_COMMUTE_TIME = 30;

export const DEFAULT_COMMUTE: Commute = {
  destination: DEFAULT_COMMUTE_DESTINATION,
  method: DEFAULT_COMMUTE_METHOD,
  time: DEFAULT_COMMUTE_TIME,
};

export const getInitialCommute = (
  commuteFilters: CommuteFilters | null,
  currentSearchPlaceName?: string | null,
): Commute => {
  if (!commuteFilters || !currentSearchPlaceName) {
    return DEFAULT_COMMUTE;
  }

  return {
    destination: {
      placeId: commuteFilters.placeId,
      label: currentSearchPlaceName,
    },
    method: commuteFilters.method,
    time: commuteFilters.time,
  };
};
